import { CloseIcon } from "../AscIcons";
import AscModal from "../AscModal/AscModal";
import AscButton from "../AscButton/AscButton";
import AscHeading from "../AscTypography/AscHeading/AscHeading";
import {
  AddressElement,
  CardElement,
  useElements,
  useStripe,
} from "@stripe/react-stripe-js";
import classNames from "classnames";
import { AscModaldDebitCreditCardPropsI } from "./AscModaldDebitCreditCard.type";
import styles from "./AscModaldDebitCreditCard.module.scss";

import { FormEvent, useCallback } from "react";
import { useAscContext } from '../../context';

const CARD_OPTIONS = {
  hidePostalCode: true,
  style: {
    base: {
      // Customize your card input styles here
      fontSize: "16px",
    },
    focus: {
      // Custom styles for when the input is focused
      boxShadow: "none",
    },
  },
};

function AscModaldDebitCreditCard({
  visible,
  setVisible,
  header,
  handleCreatePaymentMethod,
  disableSaveButton,
  setDisableSaveAction
}: AscModaldDebitCreditCardPropsI) {
  const stripe = useStripe();
  const elements = useElements();
  const {toast} = useAscContext()
  function closeModal() {
    setVisible(false);
  }

  const handleSubmit = useCallback(
    async (e: FormEvent<HTMLFormElement>) => {
      setDisableSaveAction(true)
      e.preventDefault();
      if (!stripe || !elements) {
        return;
      }

      const cardElement = elements.getElement(CardElement);
      const addressElement = elements.getElement("address");
      if (!cardElement || !addressElement) return;

      const { complete, value } = await addressElement.getValue();
      if (!complete) {
        return;
      }
      const { error, paymentMethod } = await stripe.createPaymentMethod({
        type: "card",
        card: cardElement,
      });

      if (error) {
        // Handle errors here
        toast(error.message,{type:'error'})
      } else {
        handleCreatePaymentMethod(paymentMethod.id);
        setDisableSaveAction(false)
      }
    },
    [stripe, elements]
  );

  return (
    <AscModal
      visible={visible}
      setVisible={setVisible}
      modalClassName={styles.modalClassName}
      withBackground={false}
    >
      <div className={styles.element}>
        <CloseIcon
          className={styles.closeIcon}
          onClick={closeModal}
          data-testid={"test-close-icon"}
        />
        <AscHeading className={styles.header} level={6}>
          {header}
        </AscHeading>
        <div className={styles.billing}>
          <form
            data-testid="asc-add-payment-method"
            className={classNames(styles.ground)}
            onSubmit={handleSubmit}
          >
            <CardElement options={CARD_OPTIONS} />
            <br />
            <AddressElement options={{ mode: "billing" }} />
            <div className={styles.groundFooter}>
              <AscButton type="button" variant="secondary" onClick={closeModal}>
                Cancel
              </AscButton>
              <AscButton loading={disableSaveButton} type="submit">Save</AscButton>
            </div>
          </form>
        </div>
      </div>
    </AscModal>
  );
}

export default AscModaldDebitCreditCard;
